import {
  getSectionFullCode,
  prepareSectionMetadata,
} from '../../../actions/helpers/section.helper';
import { createSection, getSections, updateSection } from '../../../actions/section.action';
import { clearSurveyCache } from '../../../actions/survey.action';

const handleSurveySectionSave = (
  sectionInfo,
  selectedSurveySectionData,
  currentSurvey,
  storeJwt
) => async (setSelectedSurveySectionData, dispatch) => {
  const codeWithSurveyData = getSectionFullCode(sectionInfo.code, currentSurvey);
  const normalizedCode = sectionInfo.code?.split('#')?.[0] ?? sectionInfo.code;

  const sectionPayload = {
    ...selectedSurveySectionData.Data,
    name: sectionInfo.title,
    code: codeWithSurveyData,
  };

  const saveSection =
    selectedSurveySectionData.Id === -1
      ? createSection(sectionPayload, storeJwt)
      : updateSection(
          selectedSurveySectionData.Id,
          sectionPayload,
          selectedSurveySectionData.Data,
          currentSurvey,
          storeJwt
        );

  await dispatch(saveSection);
  await dispatch(clearSurveyCache(currentSurvey.id, storeJwt));
  dispatch(getSections(storeJwt));

  const finalMetadata = prepareSectionMetadata(
    {
      ...selectedSurveySectionData.Data,
      name: sectionInfo.title,
      code: normalizedCode,
    },
    selectedSurveySectionData.Data,
    currentSurvey
  );

  setSelectedSurveySectionData({
    ...selectedSurveySectionData,
    Data: {
      ...finalMetadata,
      code: normalizedCode,
    },
  });
};

export default handleSurveySectionSave;
